import { sleep } from "../../../library-js/animation/sleep";
import { Loader } from "../../../library-js/dom-tools/Loader";
import { Rokojori } from "../Rokojori";
import { ProductInfo } from "./ProductInfo";
import { SerializedProductsTable } from "./SerializedProductsTable";

export class ProductsTable extends SerializedProductsTable<ProductInfo>
{
  static #instance:ProductsTable;
  static #isLoading = false;
  static async get():Promise<ProductsTable>
  {
    if ( ProductsTable.#instance )
    {
      return Promise.resolve( ProductsTable.#instance );
    }
    
    if ( ! ProductsTable.#isLoading )
    {
      ProductsTable.#isLoading = true;

      try
      {
        let rootPath = "::/_products/productsTable.json";
        let path = Rokojori.$.pathConverter.rootToRelative( rootPath );
        ProductsTable.#instance = await Loader.loadJSON<ProductsTable>( path );
      }
      catch ( e )
      {
        console.error( "Problem with products:", e );
      } 

      ProductsTable.#isLoading = false;      

    }
    else
    {
      let maxWaitDuration = 10000;
      let start = new Date().getTime();

      while ( ProductsTable.#isLoading )
      {
        let now = new Date().getTime();
        let elapsed = now - start;

        if ( elapsed > maxWaitDuration )
        {
          return Promise.resolve( null );
        }
        
        await sleep( 10 );
      }

    }


    return Promise.resolve( ProductsTable.#instance );
  }

  
  

}